export interface Invitation {
  company_name: string;
  name: string;
  email: string;
}
